var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNwFullLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 281.873,
    height: 25.616,
    viewBox: "0 0 310 25.616",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_134",
    "data-name": "Rectangle 134",
    width: 16.141,
    height: 16.141,
    fill: "#173183"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10299",
    "data-name": "Group 10299",
    transform: "translate(-45 -4764.615)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_135",
    "data-name": "Rectangle 135",
    width: 48.421,
    height: 24.211,
    transform: "translate(53.07 4766.021)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5031",
    "data-name": "Group 5031",
    transform: "translate(-48.762 4659.855)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M8.072,0,0,8.07l8.07,8.071,8.07-8.071Z",
    transform: "translate(101.832 105.905)",
    fill: "#c7006d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_131",
    "data-name": "Rectangle 131",
    width: 11.413,
    height: 11.413,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 109.902, 122.045)",
    fill: "#9c0087"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_132",
    "data-name": "Rectangle 132",
    width: 11.413,
    height: 11.413,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 128.334, 122.045)",
    fill: "#00a0e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M86.878,0,78.807,8.07l8.07,8.071,8.07-8.071Z",
    transform: "translate(40.313 104.76)",
    fill: "#3e2b82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M86.878,0,78.807,8.07l8.07,8.071,8.07-8.071Z",
    transform: "translate(14.955 113.975)",
    fill: "#f00082"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    "data-name": "Group 75",
    transform: "translate(136.404 105.905)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_133",
    "data-name": "Rectangle 133",
    width: 11.414,
    height: 11.413,
    transform: "translate(0 8.07) rotate(-44.994)",
    fill: "#173183"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_136",
    "data-name": "Rectangle 136",
    width: 48.421,
    height: 24.211,
    transform: "translate(101.832 105.905)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "NewersWorld_Learning",
    "data-name": "NewersWorld | Bootcamp",
    transform: "translate(109.873 4783.615)",
    fill: "#2c2c2c",
    fontSize: 20,
    fontFamily: "'Poppins-Medium', 'Poppins'",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "NewersWorld | "), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontFamily: "'Poppins-Medium', 'Poppins'",
    fontWeight: 700
  }, "Bootcamp")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNwFullLogo);
export default __webpack_public_path__ + "static/media/nw-full-logo.c3f59f6dfe3116f3fb387c63131454af.svg";
export { ForwardRef as ReactComponent };